import {
    useDispatch,
    useSelector,
    type TypedUseSelectorHook,
  } from "react-redux";
  import { AppDispatch, AppState } from "./store";
  
  type DispatchFunction = () => AppDispatch;
  
  export const useAppDispatch: DispatchFunction = useDispatch;
  
  export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;